import { Box, Stack, SxProps, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
import { colorCTAOrange, colorTextPrimary } from "src/design/tokens";

interface TierPerkListProps {
  /**
   * Translation keys, in the order the catalog sells them. They come straight
   * from the backend (`perkDescriptionKey` and `additionalPerks`), so a perk
   * added to the catalog only needs its key translated — never a code change.
   */
  perkKeys: string[];
  sx?: SxProps;
}

/** The checked bullet list a pricing card is mostly made of. */
export const TierPerkList = ({ perkKeys, sx }: TierPerkListProps) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={1.25} sx={sx}>
      {perkKeys.map((perkKey) => (
        <Box key={perkKey} sx={{ display: "flex", gap: 1.25 }}>
          <CheckIcon
            sx={{ color: colorCTAOrange, fontSize: 20, flexShrink: 0, mt: 0.1 }}
          />
          <Typography sx={{ fontSize: 14, color: colorTextPrimary }}>
            {t(perkKey)}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};
